module.exports = __webpack_public_path__ + "img/writing.5e725ff9.png";